import { Injector } from '@angular/core';
import { CustomGridListComponent } from './custom-grid-list.component';
import { Components } from '@formio/angular';
import { FormioCustomComponentInfo, registerExternalCustomFormioComponents } from '@pics-core/dynamic';
const editForm = Components.components.datagrid.editForm();

editForm.components[0].components.push({
  label: 'Grid Configuration',
  key: 'grid_configuration',
  components: [
    {
      label: 'Grid Page',
      widget: 'choicesjs',
      tableView: true,
      dataSrc: 'url',
      data: {
        url: '{{sessionStorage.getItem(\'apiHost\')}}/platform/page-designer/page/grid-page/all',
        headers: [
          {
            key: 'Authorization',
            value: 'Bearer {{sessionStorage.getItem(\'jwt-token\')}}'
          }
        ]
      },
      idPath: 'id',
      valueProperty: 'id',
      template: '<span>{{ item.page_name }}</span>',
      key: 'customOptions.gridId',
      type: 'select',
      lazyLoad: false,
      selectValues: 'data',
      disableLimit: true,
      noRefreshOnScroll: false,
      input: true
    },
    {
      label: 'Query Constraints',
      applyMaskOn: 'change',
      key: 'customOptions.query',
      tableView: true,
      type: 'textarea',
      input: true
    },
    {
      label: 'Add Button Label',
      applyMaskOn: 'change',
      key: 'customOptions.buttonLabel',
      tableView: true,
      type: 'textfield',
      input: true
    },
    {
      label: 'Form Page',
      widget: 'choicesjs',
      tableView: true,
      dataSrc: 'url',
      data: {
        url: '{{sessionStorage.getItem(\'apiHost\')}}/platform/page-designer/page/form-page/all',
        headers: [
          {
            key: 'Authorization',
            value: 'Bearer {{sessionStorage.getItem(\'jwt-token\')}}'
          }
        ]
      },
      idPath: 'id',
      valueProperty: 'id',
      template: '<span>{{ item.page_name }}</span>',
      key: 'customOptions.formId',
      type: 'select',
      lazyLoad: false,
      selectValues: 'data',
      disableLimit: true,
      noRefreshOnScroll: false,
      input: true
    },
    {
      label: 'Additional Fields',
      applyMaskOn: 'change',
      key: 'customOptions.fields',
      tooltip:
        'Add additional columns to be added other than the form (comma separated, ex: `user_id = {{ id }}, is_active = true`)',
      tableView: true,
      type: 'textarea',
      input: true
    },
    {
      label: 'Condition',
      applyMaskOn: 'change',
      autoExpand: false,
      tableView: true,
      key: 'customOptions.disableAdd',
      type: 'textarea',
      rows: 4,
      input: true
    },
    {
      label: 'HTML',
      attrs: [
        {
          attr: '',
          value: ''
        }
      ],
      content:
        '<h5>Example:</h5><br/>\nshowAddButton :  data.name === data.item;<br/>\nor<br/>\ndisableAddButton : data.name === data.item;',
      refreshOnChange: false,
      key: 'html',
      type: 'htmlelement',
      input: false,
      tableView: false
    },
    {
      html: '<p>Select the grid page and the respective form page of the grid.</p>',
      label: 'Content',
      customClass: 'mt-4 mb-4',
      refreshOnChange: false,
      key: 'content',
      type: 'content',
      input: false,
      tableView: false
    },
     {
      label: 'Read Only Condition',
      applyMaskOn: 'change',
      autoExpand: false,
      tableView: true,
      key: 'customOptions.readOnlyCondition',
      type: 'textarea',
      placeholder: 'Example: readOnlyCondition : data.action === \'view\'',
      rows: 4,
      input: true
    },
    {
      label: 'Is Dynamic Document Required',
      key: 'customOptions.isDynamicDocumentRequired',
      type: 'checkbox',
      input: true,
      tableView: true,
      defaultValue: false
    },
    {
      label: 'Transcript Needed',
      key: 'customOptions.isTranscriptNeeded',
      type: 'checkbox',
      input: true,
      tableView: true,
      defaultValue: false
    },
    {
      label: 'Resolve Provisions',
      key: 'customOptions.isResolveProvisions',
      type: 'checkbox',
      input: true,
      tableView: true,
      defaultValue: false
    },
    {
      label: 'Resolve Requirement',
      key: 'customOptions.isResolveRequirement',
      type: 'checkbox',
      input: true,
      tableView: true,
      defaultValue: false
    },
  ]
});

const COMPONENT_OPTIONS: FormioCustomComponentInfo = {
  type: 'customGridList',
  selector: 'app-custom-grid-list',
  group: 'advanced',
  title: 'Custom Grid List',
  icon: 'table',
  fieldOptions: ['value', 'form', 'description'],
  editForm: () => editForm,
  changeEvent: 'valueChange'
};

export function registerCustomGridListComponent(injector: Injector) {
  try {
    registerExternalCustomFormioComponents(COMPONENT_OPTIONS, CustomGridListComponent, injector);
    console.log('Custom Grid List Component Registration Done');
  } catch (error) {
    console.log('Error is register custom grid list component');
  }
}
